<template>
    <div id="app">
        <div :class='$style.header'>
            <div class='container' :class='$style.headerContainer'>
                <div :class='$style.logo'>
                    <img :class='$style.logoImg' src='../../assets/img/logo2.png' alt='logo'>
                </div>
                <ol :class='$style.nav'>
                    <li :class='$style.navItem'><a :class='$style.navLink' href="./index.html">ホーム</a></li>
                    <li :class='$style.navItem'><a :class='$style.navLink' href="./company.html">会社情報</a></li>
                    <li :class='$style.navItem'><a :class='$style.navLink' href="./page3.html">サイトポリシー</a></li>
                    <li :class='$style.navItem'><a :class='$style.navLink' href="./page4.html">プライバシーポリシー</a></li>
                </ol>
            </div>
        </div>
        
        <div v-show='!isDetail'>
            <!-- swiper1 -->
            <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                <swiper-slide class="slide-1"><img class='img' @click='switchDetail(1)'
                                                   src="../../assets/img/1920x700-4.jpg"></swiper-slide> 
                <swiper-slide class="slide-2"><img class='img' @click='switchDetail(2)'
                                                   src="../../assets/img/1920x700-2.jpg"></swiper-slide>
                <swiper-slide class="slide-3"><img class='img' @click='switchDetail(3)'
                                                   src="../../assets/img/1920x700-3.jpg"></swiper-slide>
                 <swiper-slide class="slide-4"><img class='img' @click='switchDetail(4)'
                                                   src="../../assets/img/1920x700-1.jpg"></swiper-slide>
               
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
            <!-- swiper2 Thumbs -->
            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                <swiper-slide class="slide-1"><img class='img' src="../../assets/img/1920x700-4.jpg"></swiper-slide>
                <swiper-slide class="slide-2"><img class='img' src="../../assets/img/1920x700-2.jpg"></swiper-slide>
                <swiper-slide class="slide-3"><img class='img' src="../../assets/img/1920x700-3.jpg"></swiper-slide>
                <swiper-slide class="slide-4"><img class='img' src="../../assets/img/1920x700-1.jpg"></swiper-slide>
            </swiper>
        </div>
        <div v-show='isDetail' class='container' :class='$style.detailContainer'>
            <div :class="[ $style[bgClass] , $style.banner]"></div>
            <div :class="$style.text" v-html='text'></div>
            <div :class="$style.back">
                <div @click='switchDetail(0)' :class="$style.btn">戻る</div>
            </div>
        </div>
        
        <div :class="$style.footer">© RestarGames CO.,LTD. All rights reserved.</div>
    </div>
</template>

<script>
    import {swiper, swiperSlide} from 'vue-awesome-swiper'
    
    // require styles
    import 'swiper/dist/css/swiper.css'
    
    export default {
        name: 'app',
        components: {
            swiper, swiperSlide
        },
        data() {
            return {
                isDetail: false,
                bgClass: '',
                text: '',
                swiperOptionTop: {
                    spaceBetween: 10,
                    loop: true,
                    autoplay: {
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    loopedSlides: 4, //looped slides should be the same,
                },
                swiperOptionThumbs: {
                    centeredSlides: true,
                    spaceBetween: 10,
                    slidesPerView: 4,
                    touchRatio: 0.2,
                    loop: true,
                    slideToClickedSlide: true,
                    loopedSlides: 4, //looped slides should be the same
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
            })
        },
        methods: {
            switchDetail(index) {
                
                this.isDetail = !this.isDetail
                window.scrollTo(0, 0)
                
                if (index === 0) return
                
                this.bgClass = 'b' + index
                
                var text
    
                if (index === 1) {
                    text = `<div>
                    <p>「イースⅥ」の新たな幕が開く。
日本ファルコムの30年以上続く人気RPG「イース」シリーズがアプリで登場！
舞台はエレシア大陸の遥か西。カナンの大渦に呑み込まれた冒険家――アドルがたどり着いたのは、自然と共に生きる「レダ族」が住む美しい孤島。「有翼人」の伝説と、その大いなる遺産の謎にアドルが迫る。</p>  
                    <p>◆伝説の冒険が、生まれ変わる
赤毛の冒険家と呼ばれるアドル・クリスティンが主人公の冒険ファンタジーがスマホオンラインRPGとなって、新たな冒険譚を拓く。
「イースⅥ」原作のストーリーをメインとし、過去の記憶や親密イベントなどオリジナルストーリーを加え、「イース」シリーズならではの「優しさ」を体験できる！</p>  
                    <p>◆王道冒険RPG、バリエーション豊富なコンテンツ
競技場、協力プレイダンジョン、ワールドイベントなどの冒険要素が搭載！
様々なクエストから豪華報酬が獲得可能、取引所で冒険者たちと取引することも可能！
イースの世界で自由に冒険を！</p> 
                    <p>◆高品質のアートで表現されたイースの世界
魅力あるキャラクターたちが斬新な姿で現れ、レジェンド級のボスもこの大地に再臨！
美しい冒険舞台の「カナン諸島」も、一層広大に！オープンワールドへようこそ！</p> 
                    <p>◆爽快なアクションバトルも気軽に遊べる
独自のデュアルスティック操作で精確にスキルを発動でき、華麗な戦闘を楽しめます。
４つの基本職業と８種類の上位職があり、職業スキルとチーム連携を活用し、仲間と一緒に敵を倒しましょう！
オートで手軽さ満点、忙しい時には放置で楽々プレイ！</p> 
                    <p>◆コミュニケーション要素満載、NPCもあなたの友達
便利なチームメイキングシステムと冒険団は、誰でもすぐに仲間を見つけることができます。
豊富なカスタマイズとスタンプを利用し、友情の絆も深くなります。
NPCからのメールも？キャラクターたちのストーリーを探しましょう！</p> 
                    <p>◆「イース6オンライン」に登場するキャラクター＆豪華声優陣
アドル（CV: 梶 裕貴）
オルハ（CV: 石川由依）
イーシャ（CV: 小倉 唯）
オード族長（CV: 大塚 明夫）
ガッシュ（CV: 前野 智昭）
エルンスト（CV: 関 智一）
ユエ（CV: 阿澄 佳奈）
セラ（CV: 田中 理恵）
キサ（CV: 小清水 亜美）
ローラ（CV: 川澄 綾子） and more</p> 
                    <p>◆権利表記
©Restar Games
©Nihon Falcom Corporation. All rights reserved.</p>
                    </div>`
                }
                else if (index === 2) {
                    text = '「戦姫ストライク」は、今年下半期リリース予定の新作タイトルです！百人近いの個性豊かな少女達と一緒に、ナイトメアによって崩壊しかけている世界を救いましょう！伝統的なスリングアクションゲームと違って、地形、風力、夜間戦闘などの条件を全て考慮に入れ、そして特定のボスを倒すためには戦姫達のスキルをどう組み合わせていくのかがゲームの醍醐味です。さらに少女達もそれぞれの思いや物語があって、親愛度をあげて彼女達との絆をもっと深めましょう！'
                }
                else if (index === 3) {
                    text = `<div>
<p>『わくわくファンタジー～はるかな世界の物語～』は、かわいいファンタジー異世界が舞台のRPGです。</p>
<p>キュートでポップなメルヘンワールドが忙しない現代社会に「ほっと一息つける」癒しの時間をお届けします！</p>
<p>個性的豊かな仲間たちと出会い、共に旅をしつつ、奥深いストーリーを紐解いていく冒険物語、主人公はあなたです！</p>

<p>自由に選べる4つの職業、奥深いキャラクター育成システム、100種類以上のアバター、20種類以上の常設イベント、ペット、乗騎、etc…コンテンツ数はスマホ向けRPG最大級！</p>

<p>ロマンチックな恋愛＆結婚システム、結社、オリジナルスタンプが使えるチャット等、交流系コンテンツも充実！</p>

<p>蒼井翔太さん、木村昴さん、加隈亜衣さん、佐倉綾音さん等、豪華声優陣が集結！</p>
<p>加隈亜衣さんが明るくキュートに熱唱する主題歌は必聴！</p>


<p>わくわくファンタジーの特長</p>

<p>◆ゆるっと遊べる、超キュートなRPGがカワイイ癒しをお届け</p>
<p>本作は、忙しない現代社会の日常生活の合間に「ほっと一息つける」癒しの空間をお届けすることを目指して開発されたほのぼの系RPGです。</p>
<p>キュートでポップなファンタジー世界で個性的豊かな仲間たちと出会い、共に旅をしつつ、奥深いストーリーを紐解いていく冒険物語、主人公はあなたです♪</p>


<p>◆キャラクター、アバター、自宅、ペット…・とにかく全部可愛い！</p>
<p>・個性豊かなキャラが20体以上登場！</p>
<p>ぷにぷに3頭身キャラクターが、メルヘンな世界を縦横無尽に駆け回る！</p>

<p>・100種類以上のアバターで着せ替え自由自在！</p>
<p>パンダきぐるみ、スクール水着、メイド服、猫耳娘、宇宙飛行士、バニーボーイ、軍服、etc…きっと見つかる好みのコスチューム！今後も新作アバターをどんどん追加予定です！</p>

<p>・インテリアコーディネートが楽しめる「自宅」システム</p>
<p>あなただけのマイルームを作って、友達を呼んでお茶会しよう！</p>

<p>・かわいいペットに激萌え！</p>
<p>猫ちゃん、ポニー、うさぎ、アルパカ、etc、超キュートな動物たちを仲間にして一緒に冒険しよう！</p>

<p>とにかくかわいさには自信があります！可愛いキャラクターや動物たちに癒やされてくださいね(*ﾟ∀ﾟ)</p>


<p>◆可愛いけれど本格派！いつでも飽きずに遊べるコンテンツが山盛り</p>
<p>RPGならではの4大職業、PvE、PvP、GvG等の本格バトル系コンテンツはもちろん、100種類以上のアバター、レイアウト自由自在のマイルーム等、バラエティ豊かなコンテン</p>
<p>ツを搭載！常設＆定期イベントは20種類以上！一人でも楽しい！みんなでも楽しい！いつでもどこでも、わくわく楽しく遊べる！</p>


<p>◆全国の仲間と楽しくつながるコミュニケーションツールが充実！</p>
<p>オリジナルスタンプ自作、可愛い絵文字が使えるテキストチャット、ボイスチャット、弾幕チャット、トキメキの恋愛＆結婚システム、etc、コミュニケーション系コンテンツをたっぷり搭載。</p>
<p>はるかな異世界に集う仲間たちと、楽しく交流しながら冒険しよう！</p>


<p>◆豪華制作陣が集結！目でも耳でも楽しめる魅力が満載</p>
<p>・蒼井翔太さん、加隈亜衣さん、佐倉綾音さん、木村昴さん等、第一線で活躍するベテラン声優を始め30名近くの豪華声優陣が熱演するキャラクターボイス
・実力派イラストレーターによる可愛さ満点のイラスト</p>
<p>・プロフェッショナルな音楽プロデューサーが手がける主題歌とBGM</p>

<p>声優陣　※敬称略、順不同</p>
<p>蒼井翔太・加隈亜衣・佐倉綾音・木村昴・渡辺紘・古木のぞみ・古田一紀・市来光弘・桑原由気</p>
<p>・中恵光城・河西健吾・さいとうよしえ・中村太亮・チャオ・奥村翔・坂泰斗・半澤敦史・本多諒太・村上聡・難波祐香・秋谷啓斗・臼木健士朗・丸山徹・神田みか・永牟田萌・卯佐乃心月・木田祐・中村桜</p>

<p>◆加隈亜衣さんが歌う主題歌は必聴！</p>
<p>加隈亜衣さんがキュートに熱唱する主題歌は、明るくハッピーになれるポジティブパワーでいっぱい！ぜひ聴いて元気になってくださいね！</p>
</div>`
                }
                else {
                    text =  `<div>
<p>正統Hip-Hop風ストリートバスケ対戦スマホゲーム「シティダンク：フリースタイル」！バスケの醍醐味である様々なテクニックを再現し、それらを駆使して3分間のリアルタイム3対3チーム対戦で極限まで燃えつくせ！更に数多の個性溢れる3Ðキャラクターが存在し、様々なスキルを自分で任意に選ぶことができ、色んな衣装を好みにカスタイマイズし、自分だけの選手を育成できます！完璧に再現されたストリートの背景で友達と一緒に様々なゲームモード（ランク、ストーリ、対戦）で対戦or協力してストリートバスケを堪能せよ！</p>

<p>1.	システム紹介ースキルの組み合わせ
スキルはアクティブスキルと天賦スキルの2種類あり、ポジション毎にも区別されてます。アクティブスキルは自由に装備でき、もし装備に迷った時は玄人の勧めやおまかせ装備で装備する事もできるよ。それ以外に、各ポジションのスキルの組み合わせも非常にこだわりがあり、相性がいいスキルでは強力な組みあわせができ、それと反対に相性が悪いスキルもあるよ。</p>

<p>2.	システム紹介ー様々な衣装スキン
衣装スキンはキャラクターの外見を一変するだけでなく、ステータスの強化もできます。スキンは髪型、上着、ズボン、靴、アクセサリーの五種類で、更にその中のアクセサリーは眼鏡、マスク、リストバンド、翼、ペンダントの種類があり自由に組み合わせる事が可能です。実戦重視の場合、自分に必要なステータスのスキンを選ぶのもいいと思います!</p>
</div>`
                }
                this.text = text
                
            }
        }
    }
</script>

<style lang="scss">
    
    @import '../../assets/scss/reset';
    
    html {
        height: 100%;
    }
    
    body {
        max-width: 1920px;
        min-width: 1190px;
        margin: 0 auto;
        min-height: 100%;
        padding-bottom: 147px;
        position: relative;
        font-size: 18px;
    }
    
    .container {
        width: 1190px;
        margin: 0 auto;
    }
    
    .gallery-thumbs {
        padding: 10px 0;
    }
    
    .gallery-thumbs .swiper-slide {
        width: 33.33%;
        opacity: 0.4;
    }
    
    .gallery-thumbs .swiper-slide-active {
        opacity: 1;
    }
    
    .swiper-container .img {
        display: block;
        width: 100%;
        height: auto;
        cursor: pointer;
    }
    
    .gallery-thumbs {
        height: 190px;
        
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
    }

</style>

<style module lang=scss>
    
    .header {
        background-image: linear-gradient(90deg, #fff 0%, #EFEFEF 50%, #fff 100%);
        height: 54px;
    }
    
    .headerContainer {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .logo {
        width: 90px;
        height: 100%;
        display: flex;
        align-items: center;
        /*background: url(../../assets/img/logo.png) no-repeat center;*/
        /*background-size: 100% auto;*/
    
        img {
            display: block;
            width: 100%;
            height: auto;
        }
    }

    /*.logoImg {*/
    /*display: none;*/
    /*}*/
    
    .nav {
        display: flex;
    }
    
    .navLink {
        font-weight: bold;
        color: #000;
        padding-left: 80px;
        
        &:hover {
            color: #ff7f1d;
        }
    }
    
    .footer {
        background-image: linear-gradient(90deg, #fff 0%, #EFEFEF 50%, #fff 100%);
        height: 147px;
        line-height: 147px;
        color: #434343;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    
    .detailContainer {
        margin-top: 40px;
    }
    
    .banner {
        height: 200px;
        background-size: 100% auto;
        
        &.b1 {
            background: url(../../assets/img/1920x700-4.jpg) no-repeat center;
        }
        
        &.b2 {
            background: url(../../assets/img/1920x700-2.jpg) no-repeat center;
        }
        
        &.b3 {
            background: url(../../assets/img/1920x700-3.jpg) no-repeat center;
        }

        &.b4 {
            background: url(../../assets/img/1920x700-1.jpg) no-repeat center;
        }
        
    }
    
    .text {
        padding: 40px 60px;
        line-height: 1.6;
        
        p {
            margin-bottom: 20px;
        }
    }
    
    .back {
        height: 200px;
        border-top: 1px solid #ccc;
        margin-top: 80px;
        padding-top: 50px;
        padding-left: 60px;
        
    }
    
    .btn {
        width: 145px;
        height: 45px;
        line-height: 45px;
        background-color: #000;
        color: #fff;
        text-align: center;
        cursor: pointer;
    }

</style>
